
import moment from "moment/moment"

export const formatedate = (date)=>{
     return moment(date).format('MMM DD, YYYY')
}


export const formatedateTime = (date)=>{
    return moment(date).format('MMM DD, YYYY hh:mm A')
}